import { useModal } from "@/hooks";
import { Button } from "@/components/Buttons/index";
import modalStyles from "@/styles/Modal.module.scss";

export default function IdcCooperationSignUpModal({ onClickHandle }) {
  const { hideModal } = useModal();
  return (
    <div className={modalStyles.signup}>
      <p className={modalStyles.text}>重要</p>
      <p className={modalStyles.text}>
        すでにSPOOX IDをお持ちの方が新規でSPOOX利用登録をされますと、
        ご契約中の商品をご視聴できなくなりますのでご注意ください。
      </p>

      <Button
        type="button"
        fillMainColor
        large
        onClick={onClickHandle}
        fontBold
      >
        SPOOX利用登録する
      </Button>
      <Button
        type="button"
        fillColor
        large
        fillGray
        fontBold
        style={{ marginTop: "14px" }}
        onClick={hideModal}
      >
        戻る
      </Button>
    </div>
  );
}
